import { useState, useEffect } from "react";

export function useDataLayer(...data) {
  const [dataLayerFired, setDataLayerFired] = useState(false);

  useEffect(() => {
    if (!dataLayerFired) {
      if (window && window.dataLayer) {
        window.dataLayer.push(...data);
      }
      setDataLayerFired(true);
    }
  }, [dataLayerFired]);
}
